import {Component, DOCUMENT, inject, OnInit, SecurityContext} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'legacy-domain-notice-banner',
  templateUrl: './legacy-domain-notice-banner.component.html',
  styleUrls: ['./legacy-domain-notice-banner.component.scss'],
  standalone: false
})
export class LegacyDomainNoticeBannerComponent implements OnInit {
  private readonly EXPIRY_DATE = new Date(2026, 9, 1);
  private readonly NEW_DOMAIN = 'bavelpay.com';
  private readonly WWW_NEW_DOMAIN = 'www.bavelpay.com';
  private readonly document = inject(DOCUMENT);
  private readonly translateService = inject(TranslateService);
  private readonly sanitizer = inject(DomSanitizer);

  public visible: boolean = false;
  public safeMaintenanceBannerMessage: SafeHtml = '';

  public ngOnInit(): void {
    const hostname = this.document.location.hostname;
    const isOnNewDomain = hostname === this.NEW_DOMAIN || hostname === this.WWW_NEW_DOMAIN || hostname.endsWith(`.${this.NEW_DOMAIN}`);
    const isBannerActive = new Date() < this.EXPIRY_DATE;

    this.visible = !isOnNewDomain && isBannerActive;
    this.safeMaintenanceBannerMessage = this.sanitizer.sanitize(
      SecurityContext.HTML,
      this.translateService.instant('scheduled_maintenance_banner_message')
    ) ?? '';
  }
}